import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import AddCardIcon from '@mui/icons-material/AddCard';

interface PendingBalanceBadgeProps {
    amount: number;
    position?: {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
        transform?: string;
    };
}

const PendingBalanceBadge: React.FC<PendingBalanceBadgeProps> = ({ amount, position }) => {
    return (
        <Tooltip title={`+$${amount.toFixed(2)} will be added next hand`}>
            <Box
                sx={{
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'rgba(46, 125, 50, 0.95)',
                    borderRadius: '12px',
                    padding: '4px 8px',
                    gap: '4px',
                    zIndex: 9999,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    ...position,
                }}
            >
                <AddCardIcon sx={{ fontSize: 14, color: '#fff' }} />
                <Typography
                    sx={{
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#fff',
                        fontFamily: '"Inter", serif',
                        whiteSpace: 'nowrap',
                    }}
                >
                    +${amount.toFixed(2)}
                </Typography>
            </Box>
        </Tooltip>
    );
};

export default PendingBalanceBadge; 